
const ReplyForm = ({ isOpen, onClose, onSubmit, commentId }) => {
  if (!isOpen) return null;

  const handleSubmit = (e) => {
    e.preventDefault();
    const reply = e.target.reply.value;
    onSubmit(commentId, reply);
    onClose();
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center">
      <div className="bg-white p-6 rounded-lg w-96">
        <div className="flex justify-between items-center mb-4">
          <h3 className="text-lg font-medium">پاسخ به نظر</h3>
          <button
            onClick={onClose}
            className="text-gray-500 hover:text-gray-700"
          >
            <span className="text-2xl">&times;</span>
          </button>
        </div>
        <form onSubmit={handleSubmit}>
          <textarea
            name="reply"
            className="w-full p-2 border rounded-lg mb-4 min-h-[100px]"
            placeholder="پاسخ خود را بنویسید..."
            required
          />
          <div className="flex justify-end gap-2">
            <button
              type="button"
              onClick={onClose}
              className="px-4 py-2 border rounded-lg hover:bg-gray-100"
            >
              انصراف
            </button>
            <button
              type="submit"
              className="px-4 py-2 bg-blue-500 text-white rounded-lg hover:bg-blue-600"
            >
              ارسال پاسخ
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ReplyForm;
